import { TNotification, TNotificationType } from './types';
import { Tag } from 'antd';

export const notifications: TNotification[] = [
  {
    id: 1,
    title:
      'Trần Thanh Hương đã thêm comment trong Công việc Xử lý văn bản đi: Test lúc 4.33 TY',
    date: '17/11/2025',
    type: 'work',
  },
  {
    id: 2,
    title:
      'Nguyễn Thị Phương Lan đã thêm comment trong Công việc Test nguyên thị phuong lan',
    date: '17/11/2025',
    type: 'work',
  },
  {
    id: 3,
    title: 'Bạn có công việc mới Test nguyên thị phuong lan',
    date: '17/11/2025',
    type: 'document',
    isRead: true,
  },
  {
    id: 4,
    title: 'Một văn bản của bạn đã bị xóa: Xử lý văn bản đi',
    date: '17/11/2025',
    type: 'system',
    isRead: true,
  },
  {
    id: 5,
    title:
      'Admin đã thêm bạn là người xử lý Quy trình xin ý kiến Test lúc 10.13.',
    date: '17/11/2025',
    type: 'opinion',
    isRead: true,
  },
];

export const renderTag = (type: TNotificationType) => {
  switch (type) {
    case 'work':
      return (
        <Tag className="m-0 rounded-[4px] border-0 bg-[#E9F0FF] px-2 py-1 text-xs text-[#4680FF]">
          Công việc
        </Tag>
      );
    case 'document':
      return (
        <Tag className="m-0 rounded-[4px] border-0 bg-[#FCF1E0] px-2 py-1 text-xs text-[#E58A00]">
          Văn bản đến
        </Tag>
      );
    case 'system':
      return (
        <Tag className="m-0 rounded-[4px] border-0 bg-[#FFF0F6] px-2 py-1 text-xs text-[#EB2F96]">
          Hệ thống
        </Tag>
      );
    case 'opinion':
      return (
        <Tag className="m-0 rounded-[4px] border-0 bg-[#E6F5F0] px-2 py-1 text-xs text-[#2CA87F]">
          Lấy ý kiến
        </Tag>
      );
    default:
      return null;
  }
};
